module.exports = __webpack_public_path__ + "img/lilac.2d6988a7.webp";